module.exports = __webpack_public_path__ + "public-ui/fonts/cyrillic.40ee6416.woff2";